import { render, staticRenderFns } from "./catStyleDet.vue?vue&type=template&id=6c5c01da&scoped=true&"
import script from "./catStyleDet.vue?vue&type=script&lang=js&"
export * from "./catStyleDet.vue?vue&type=script&lang=js&"
import style0 from "./catStyleDet.vue?vue&type=style&index=0&id=6c5c01da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5c01da",
  null
  
)

export default component.exports